import React from 'react';
import { notification } from 'antd';

const openNotificationWithIcon = function (type, title, description, confirmBtn, onClick, config) {
  const handleOnClickBtn = () => {
    onClick();
    notification.destroy();
  };

  const btn = <span onClick={handleOnClickBtn}>{confirmBtn}</span>;

  const params = {
    message: title,
    description: description,
    btn: confirmBtn ? btn : '',
  };

  if (config) {
    params.duration = 30;
  }

  const notice = notification[type](params);

  return <>{notice}</>;
};

export const Notification = {
  success: function (title, description, confirmBtn, onClick) {
    notification.destroy();
    openNotificationWithIcon('success', title, description, confirmBtn, onClick);
  },
  info: function (title, description, confirmBtn, onClick, config) {
    notification.destroy();
    openNotificationWithIcon('info', title, description, confirmBtn, onClick, config);
  },
  warning: function (title, description, confirmBtn, onClick) {
    notification.destroy();
    openNotificationWithIcon('warning', title, description, confirmBtn, onClick);
  },
  error: function (title, description, confirmBtn, onClick) {
    notification.destroy();
    openNotificationWithIcon('error', title, description, confirmBtn, onClick);
  },
};
